import { featuredCollectionsResponseSchema } from '@/types/featured-collections';
import { apiRequest } from './client';

const BASE = '/api/v1/featured-collections';

export async function getFeaturedCollections(gameweekId: string) {
  const query = new URLSearchParams({ gameweek_id: gameweekId });
  const url = `${BASE}?${query.toString()}`;
  const res = await apiRequest<unknown>({ url, method: 'GET' });
  return featuredCollectionsResponseSchema.parse(res);
}
